import { Route, Routes } from 'react-router-dom';
import { ShowMyDocuments } from './ShowMyDocuments';

export const DocumentsRouter = () => (
  <Routes>
    <Route path="/" element={<ShowMyDocuments />} />
  </Routes>
);
